export default {
  test: 'test',
};


// WEBPACK FOOTER //
// ./src/locales/en-US/test.ts